import React from 'react';
import { Canvas, IText } from 'fabric';
import { ToolbarColorPicker } from '../../../shared/ui/color-picker';
import { useTextFill } from '../../hooks/use-text-fill';

interface ColorControlProps {
  textObject: IText;
  canvas: Canvas;
}

export const ColorControl: React.FC<ColorControlProps> = ({ textObject, canvas }) => {
  const [color, setColor] = useTextFill(textObject, canvas, '#000000');
  return <ToolbarColorPicker value={color} onChange={setColor} />;
};
